export default __webpack_public_path__ + "d9bb5b76a1dfb795d00053c394578c95.svg";